import React from "react";
import SRB from "../assets/rosoftsavvy.png";
export default function Logo() {
  return <img src={SRB} alt='RSS Logo' width={40} height={"auto"} />;
}
